module.exports = __webpack_public_path__ + "img/porsche-design-system.ee4f1647.jpg";